export default __webpack_public_path__ + "static/media/img-0809-czech-republic-full-face.ce14261c.png";